(async function () {
  const root = document.querySelector('[data-orange-circle]');
  const base = root?.dataset.root || window.Shopify?.routes?.root || '/';
  const api = base + 'apps/orange-circle/';
  const storageKey = 'oe-circle-direct-referral';
  let referralToken = null;
  try { referralToken = sessionStorage.getItem(storageKey); } catch {}
  const ref = new URL(location.href).searchParams.get('ref');
  if (ref && /^[A-Za-z0-9_-]{16,80}$/.test(ref)) {
    try {
      const response = await fetch(api + 'referral?ref=' + encodeURIComponent(ref), {credentials:'same-origin',cache:'no-store'});
      if (response.ok) {
        const data = await response.json();
        if (typeof data.token === 'string') {
          referralToken = data.token;
          try { sessionStorage.setItem(storageKey, referralToken); } catch {}
          await fetch(base + 'cart/update.js', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{orange_circle_referral:referralToken}})});
        }
      }
    } catch {}
  }
  if (!root || root.dataset.enabled !== 'true') return;
  const t = JSON.parse(root.querySelector('[data-circle-translations]').textContent);
  const el = name => root.querySelector(`[data-${name}]`);
  const status = el('circle-status');
  let csrf, redeemId = null, busy = false;
  const money = pence => new Intl.NumberFormat('en-GB', {style:'currency',currency:'GBP'}).format(pence/100);
  async function request(path, body) {
    const response = await fetch(api + path, {method:body?'POST':'GET',credentials:'same-origin',cache:'no-store',headers:body?{'Content-Type':'application/json'}:{},body:body?JSON.stringify({...body,csrf}):undefined});
    const data = await response.json().catch(()=>({}));
    if (!response.ok) { const error = new Error(t.error); error.status=response.status; throw error; }
    return data;
  }
  function render(data) {
    if (data.csrf) csrf = data.csrf;
    el('login-link').hidden = true;
    el('join').hidden = data.member;
    el('dashboard').hidden = !data.member;
    status.textContent = data.member ? t.welcome : '';
    if (!data.member) return;
    el('balance').textContent = String(data.balance);
    el('worth').textContent = money(data.redeemablePence);
    el('redeem').disabled = busy || data.balance < 500;
    const link = new URL(base + 'pages/orange-circle', location.origin);
    link.searchParams.set('ref', data.code);
    el('referral-link').value = link.href;
    const rewards=el('rewards');rewards.replaceChildren();
    for(const reward of data.rewards){const li=document.createElement('li'),code=document.createElement('code'),amount=document.createElement('span');code.textContent=reward.status==='active'?reward.code:reward.status==='used'?t.used:t.pending;amount.textContent=money(reward.pence);li.append(code,amount);rewards.append(li);}
    if(!data.rewards.length){const li=document.createElement('li');li.textContent=t.noRewards;rewards.append(li);}
    const history=el('history');history.replaceChildren();
    for(const entry of data.history){const li=document.createElement('li'),label=document.createElement('span'),points=document.createElement('span');const type=entry.source.split(':')[0];label.textContent=t[type]||t.adjustment;points.textContent=(entry.delta>0?'+':'')+String(entry.delta);li.append(label,points);history.append(li);}
    if(!data.history.length){const li=document.createElement('li');li.textContent=t.noHistory;history.append(li);}
  }
  el('join').addEventListener('click',async()=>{
    if(busy)return;busy=true;el('join').disabled=true;
    try{render(await request('join',{referralToken}));}catch{status.textContent=t.error;}
    finally{busy=false;el('join').disabled=false;}
  });
  el('redeem').addEventListener('click',async()=>{
    if(busy)return;busy=true;el('redeem').disabled=true;redeemId ||= crypto.randomUUID();
    try{const data=await request('redeem',{points:500,requestId:redeemId});render(data);el('redeem-status').textContent=data.pending?t.pending:'';redeemId=null;}
    catch{el('redeem-status').textContent=t.error;}
    finally{busy=false;try{render(await request('member'));}catch{}}
  });
  el('copy').addEventListener('click',async()=>{
    const input=el('referral-link');
    try{await navigator.clipboard.writeText(input.value);el('copy').textContent=t.copied;setTimeout(()=>{el('copy').textContent=t.copy;},2000);}catch{input.focus();input.select();}
  });
  try{render(await request('member'));}
  catch(e){if(e.status!==401){status.textContent=t.error;el('login-link').hidden=true;}}
})();
